import React from 'react';
import PropTypes from 'prop-types';
import { BackButton } from 'web-ui-components/lib/molecules/navigation';
import { SimplePanel } from 'web-ui-components/lib/layout/content';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { Title } from 'web-ui-components/lib/atoms/text';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { TextStyled } from 'web-ui-components/lib/atoms/text';
import AccountPickerWrapper from '../accountpicker/AccountPickerWrapper';
import UserManagementStore from '../../stores/UserManagementStore';
import FavouritesStore from '../../stores/AccountsStore/FavouritesStore';
import InternetBankingActions from '../../actions/InternetBankingActions';
import { RequiresAuthenticatedUser } from '../RequiresAuthenticatedUser';

class AccountPickerPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      backUrl: FavouritesStore.getAccountPickerBackUrl(),
      accounts: FavouritesStore.getAll(),
      onSelectAccount: FavouritesStore.getAccountPickerOnSelect(),
      user: UserManagementStore.getCADetails(),
    };
    this.handleStoreChange = this.handleStoreChange.bind(this);
  }

  componentDidMount() {
    FavouritesStore.addChangeListener(this.handleStoreChange);
  }

  componentWillUnmount() {
    FavouritesStore.removeChangeListener(this.handleStoreChange);
  }

  handleStoreChange() {
    this.setState({
      accounts: FavouritesStore.getAll(),
    });
  }

  render() {
    const { content, session } = this.props;
    const { accounts, onSelectAccount, user, backUrl } = this.state;
    return (
      <div id="page" className="bow page accountpicker__standalonepage">
        <div className="web-ui-components accountpicker accountpicker__page">
          <BackButton
            onClick={() => InternetBankingActions.navigateToWebTask(backUrl)}
          />
          <SimplePanel>
            <Title size="h3">{content.accountPickerPageTitle}</Title>
            <TextStyled size="arran">
              {content.accountPickerPaymentsChoose}
            </TextStyled>
            <StandardBody>
              {content.accountPickerPageChooseAccount}
            </StandardBody>
            <AccountPickerWrapper
              user={user}
              session={session}
              favourites={accounts}
              onSelectAccount={onSelectAccount}
              content={content}
            />
          </SimplePanel>
          <Button
            display="secondary"
            onClick={() => InternetBankingActions.navigateToWebTask(backUrl)}
          >
            {content.accountPickerPageBack}
          </Button>
        </div>
      </div>
    );
  }
}

AccountPickerPage.propTypes = {
  session: PropTypes.shape({
    accessToken: PropTypes.string.isRequired,
  }).isRequired,
};

export default RequiresAuthenticatedUser(AccountPickerPage);
